export default __webpack_public_path__ + "static/media/loginImg.a5d751a7.png";